import React from 'react';

import { List, ListItemButton, ListItemText } from '@mui/material';

export default function HoverNav() {
  return (
    <List sx={{ position: 'fixed', top: 70, width: '154px' }}>
      <ListItemButton component="a" href="#overview">
        <ListItemText primary="Overview" />
      </ListItemButton>
      <ListItemButton component="a" href="#definitions">
        <ListItemText primary="Definitions" />
      </ListItemButton>
      <ListItemButton component="a" href="#classification">
        <ListItemText primary="Classifications" />
      </ListItemButton>
      <ListItemButton component="a" href="#pulish">
        <ListItemText primary="Publish" />
      </ListItemButton>
      <ListItemButton component="a" href="#history">
        <ListItemText primary="Bid History" />
      </ListItemButton>
    </List>
  );
}
